import { createFileRoute } from '@tanstack/react-router'
import AddRewardForm from '@/features/rewards/components/AddRewardForm'
import { LayoutCard } from '@/components/layouts/LayoutCard'

export const Route = createFileRoute('/_authed/rewards/new')({
  component: AddRewardRoute,
})

function AddRewardRoute() {
  return (
    <LayoutCard title="Add reward" subtitle="Create a new reward for your household.">
      <AddRewardForm />
    </LayoutCard>
  )
}
